import { Row, Spin, Typography, Col } from "antd";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import HTTPClient from "../../utils/HTTPClient";
import { GoToStore } from "./components/GoToStore";
import { News } from "./components/News";
import { LastApp } from "./components/LastApp";
import { Builder } from "./components/Builder";
import { useTranslation } from "react-i18next";

export default function Home({}) {
    const [countApp, setCountApp] = useState(null);
    const [freeTierCount, setFreeTierCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();

    const fetch = async () => {
        setLoading(true);

        const apps_res = await HTTPClient.get("/app/");

        setCountApp(apps_res?.data?.length);
        if (apps_res?.data)
            setFreeTierCount(
                apps_res?.data?.filter((a) => a.resource_id === "free" && a.active).length
            );
        setLoading(false);
    };

    useEffect(() => {
        fetch();
    }, []);

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    if (loading) return <Spin size="large" />;

    return (
        <>
            <Row
                style={{
                    padding: isLargeScreen ? "20px 50px" : "10px 10px",
                    display: "flex",
                    justifyContent: "center",
                }}>
                <Typography.Text
                    style={{ fontSize: "x-large", fontWeight: "bold", textAlign: "center" }}>
                    {t("home.title")}
                </Typography.Text>
            </Row>
            <Row
                style={{
                    padding: isLargeScreen ? "20px 50px" : "10px 10px",
                    display: "flex",
                    justifyContent: "space-between",
                }}>
                <Col xs={24} s={24} md={24} lg={7} xl={7}>
                    <Builder />
                </Col>
                <Col xs={24} s={24} md={24} lg={7} xl={7}>
                    {countApp > 0 ? <LastApp /> : <News />}
                </Col>
                <Col xs={24} s={24} md={24} lg={7} xl={7}>
                    <GoToStore freeTierCount={freeTierCount} />
                </Col>
            </Row>
        </>
    );
}
